// AdminHome.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../Contexts/AuthContext';
import AdminLayout from '../AdminLayout';
import styles from './AdminHome.module.scss';

const AdminHome: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const adminCards = [
    {
      title: "EasyMove Mobile",
      description: "Versão completa para computadores com recursos avançados de gerenciamento",
      version: "Development",
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      ),
      color: "#3B82F6",
      route: "/admin/easymove"
    }
  ];

  return (
    <AdminLayout>
      <div className={styles.adminHome}>
        <div className={styles.heroSection}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>
              Bem-vindo ao Painel Administrativo
            </h1>
            <p className={styles.heroSubtitle}>
              Olá, <span className={styles.userName}>{user?.displayName || user?.email}</span>
            </p>
            <p className={styles.heroDescription}>
              Plataforma Centralizada administrativa para gerenciamento de arquivos e informações.
            </p>
          </div>
        </div>

        <div className={styles.dashboardSection}>
          <h2 className={styles.sectionTitle}>Módulos Disponíveis</h2>
          <div className={styles.cardsGrid}>
            {adminCards.map((card, index) => (
              <div 
                key={index} 
                className={styles.adminCard}
                onClick={() => navigate(card.route)}
                style={{ '--card-color': card.color } as React.CSSProperties}
              >
                <div className={styles.cardHeader}>
                  <div className={styles.cardIcon}>{card.icon}</div>
                  <div className={styles.cardVersion}>{card.version}</div>
                </div>
                <div className={styles.cardContent}>
                  <h3 className={styles.cardTitle}>{card.title}</h3>
                  <p className={styles.cardDescription}>{card.description}</p>
                </div>
                <div className={styles.cardFooter}>
                  <span className={styles.cardAction}>Acessar →</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminHome;